// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

// Media
import loginBackgroundSuperior from '../../media/images/loginBackgroundSuperior.avif';
import loginSizeMediumCoverSuperior from '../../media/images/loginSizeMediumCoverSuperior.avif';

export const LeftPanel = styled.div`
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.color.leftPanelImageRight.backgroundColor};

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 3.5rem 4rem;
    border-radius: 1rem;
    max-width: 500px;
    width: 100%;
    height: max-content;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 2rem;
    background-color: transparent;
    max-width: none;
    height: 100vh;
  };
`;

export const CoverContainer = styled.div`
  background-color: ${({ theme }) => theme.color.leftPanelImageRight.backgroundColor};
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 15em 3rem;
    background-image: 
      linear-gradient(
        ${({ theme }) => theme.color.leftPanelImageRight.overlayMediumColor}, 
        ${({ theme }) => theme.color.leftPanelImageRight.overlayMediumColor}
      ),
      url(${loginSizeMediumCoverSuperior});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 0;
    background-image: none;
    background-color: transparent;
  };
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    justify-content: flex-start;
  };
`;

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg}px) {
    padding-top: 4rem;
  };
`;

export const ImageContainer = styled.div`
  @media (min-width: ${BREAKPOINTS.md}px) {
    display: flex;
    margin-left: -2rem;
    padding: 8px;
    height: 100vh;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px) {
    margin-left: -2rem;
  };

  @media (min-width: ${BREAKPOINTS.xl}px) and (max-width: ${BREAKPOINTS.xxl}px) {
    margin-left: -4rem;
  };

  @media (min-width: ${BREAKPOINTS.xxl}px) {
    margin-left: -5.5rem;
  };
`;

export const Image = styled.div`
  height: 100%;
  width: 100%;
  flex: 1;
  background-repeat: no-repeat;
  background-image: url(${loginBackgroundSuperior});
  background-size: cover;
  background-position: bottom left;
`;

export const NeedHelpContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  z-index: 1;
  position: relative;
  padding-top: 3rem;
  padding-bottom: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-top: 4rem;
    padding-bottom: 3rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px) {
    p > a {
      overflow-wrap: break-word; 
      word-break: normal;
      display: inline-block;
      white-space: auto-wrap;
    };
    p {
      color: blue;
      overflow-wrap: break-word;
      display: inline;
      box-sizing: border-box;
      max-width: 70%;
    };
  };

  @media (min-width: ${BREAKPOINTS.xl}px) {
    justify-content: end;
    align-items: end;
    padding-top: 0;
    padding-bottom: 0;
    height: 100%;
  };
`;
